module.exports = __webpack_public_path__ + "img/132.e3d32e2.jpg";